module.exports = __webpack_public_path__ + "img/64_5.bac919b2.png";